var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_1871",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_1871",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACf0lEQVR4nO3cwWoTYRDA8f+nbSIk0H4+gW8jGxBaoYInLYLexKu39ODBoy9gexGhFYsICX0bD55dxQ1tDLieLB5km4PONzM7/2N2YYcfScguQyCKoiiKoiiKoiiKoshPqfQAIlWz4fb29xcppX1gCLwZrXj2+eTeudQIG1IXKlY1G+bcnEKq/nj18WITgCdSY1yTulCRLpGp/nL0vuQofqG7kQF+So7jE/pqZFrSa8GJHEKvgQzMv9aj51IjgTfoveNBzs0J3chnW4PFXeaTpdRY4Onn3d7xIG/yDrjTcdbZ1mCx8+lo/0JqrN/5gFaODB6gDSCDdWgjyGAZ2hAyWIU2hgwWoQ0igzVoo8hgCdowMliBNo4MFqAdIIN2aCfIoBnaETJohXaGDBqhHSKDNminyKAJ2jEyaIF2jgwaoHuADKWhe4IMJaF7hAyloHuGDCWge4gM0tBrLrfU9XhXeu/ifye6QJPz4oAeIoP0plJqH3QcLbJBJJWvlTDFSUMfdRy7/e3H6D3VbCg2jWCi0PWX8RSYd5xS5dycesSWfUfPJ8t6xQ7wseOsKufmw62HhzekxpIobliEiltwoeKhklDxmFSo8tDQC2wd0OAeWw80uMbWBQ1usfVBg0tsndDgDlsvNLjC1g0NbrD1Q4MLbBvQYB7bDjSYxrYFDWax7UGDSWyb0GAO2y40mMK2DQ1msO1DgwlsH9CgHtsPNKjG9gUNajdW/e3ezSfLuh7vcsVG1M3cvJQaCTxCw1rYLTyCVuwT7RMa1sHeYHoQ0P+kDuxE+5bpVOyPYH1DwyV2gldAA1wk2sPrq/S09GiOa5Pk93IURVEURVEURVEUReL9AjPRwEEZeDBWAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.51f8d9cec1934d3dee379e886afffbb3.svg";
export { ForwardRef as ReactComponent };